<!-- Bar Chart - ng2-charts (Chart.js) -->
<div class="bar-chart-container">
  @if (legendItems.length > 0) {
  <div class="domain-legend">
    @for (item of legendItems; track item.name) {
    <div class="legend-item">
      <img [src]="item.faviconUrl" [alt]="item.name" class="legend-favicon" (error)="onFaviconError($event)" />
      <span class="legend-color" [style.background]="item.color"></span>
      <span class="legend-name">{{ item.name }}</span>
    </div>
    }
  </div>
  }
  <div class="chart-wrapper">
    <div class="chart-section">
      <div class="chart-inner">
        <canvas baseChart
          [data]="barChartData"
          [type]="barChartType"
          [options]="barChartOptions">
        </canvas>
      </div>
    </div>
  </div>
</div>
